export default "__VITE_ASSET__79386731__"